const azkarKhlaaData = {
  brand: "أذكار الخلاء",
  list: [
    {
      id: 1,
      title: "الذكر عند الخلاء",
      text: [
        "(بِسْمِ الله) اللّهُـمَّ إِنِّـي أَعـوذُ بِـكَ مِـنَ الْخُـبْثِ وَالْخَبائِث.",
      ],
    },
    {
      id: 2,
      title: "الذكر بعد الخروج من الخلاء",
      text: ["غُفْـرانَك. "],
    },
  ],
};

export default azkarKhlaaData;
